import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';


// Modules
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared.module';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Pipes
import { SearchFilterPipe } from './pipes/search-filter.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { RemoveDuplicatesPipe } from './pipes/remove-duplicates.pipe';

// Authorization
import { AuthInterceptor } from './auth/AuthInterceptor';

// Services
import { ListBooksService } from './services/list-books.service';
import { ContributorService } from './services/contributor.service';
import { PagerService } from './services/pager.service';
import { BibliographyService } from './services/bibliography.service';

// Components
import { AppComponent } from './app.component';
import { SearchBooksComponent, DialogConfirmSearchComponent } from './components/search-books/search-books.component';
import { ListBooksComponent, DialogConfirmDeleteBook } from './components/list-books/list-books.component';
import { EditBookComponent } from './components/edit-book/edit-book.component';
import { DialogContributorsComponent } from './components/dialog-contributors/dialog-contributors.component';
import { DialogPublishersComponent } from './components/dialog-publishers/dialog-publishers.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { ListContributorsComponent } from './components/list-contributors/list-contributors.component';
import { AddEditContributorComponent, DialogNewContributorComponent, PageNewContributorComponent } from './components/add-edit-contributor/add-edit-contributor.component';
import { DiversitySubjectComponent } from './components/diversity-subject/diversity-subject.component';
import { BookCharactersComponent } from './components/book-characters/book-characters.component';
import { BookRecommendationComponent } from './components/book-recommendation/book-recommendation.component';
import { DialogConfirmDeleteCCBCSubject, DialogCCBCSubjectsComponent } from './components/dialog-ccbcsubjects/dialog-ccbcsubjects.component';
import { GenerateReportComponent } from './components/generate-report/generate-report.component';
import { EditBibliographyComponent } from './components/edit-bibliography/edit-bibliography.component';
import { DialogBibliographyBookComponent } from './components/dialog-bibliography-book/dialog-bibliography-book.component';
import { DialogAssignBibliographyComponent } from './components/dialog-assign-bibliography/dialog-assign-bibliography.component';
import { DialogConfirmDeleteBibliography } from './components/list-bibliography/list-bibliography.component';

//tinymce
import { EditorModule } from '@tinymce/tinymce-angular';

//angular-tree-component
import { TreeModule } from 'angular-tree-component';
import { ListBibliographyComponent } from './components/list-bibliography/list-bibliography.component';


@NgModule({
  declarations: [
    AppComponent,
    SearchBooksComponent,
    ListBooksComponent,
    EditBookComponent,
    DialogContributorsComponent,
    DialogPublishersComponent,
    MultiSelectComponent,
    ListContributorsComponent,
    AddEditContributorComponent,
    DialogNewContributorComponent,
    PageNewContributorComponent,
    SearchFilterPipe,
    TimeAgoPipe,
    OrderByPipe,
    RemoveDuplicatesPipe,
    DiversitySubjectComponent,
    BookCharactersComponent,
    BookRecommendationComponent,
    DialogConfirmDeleteCCBCSubject,
    DialogCCBCSubjectsComponent,
    DialogConfirmDeleteBook,
    DialogConfirmDeleteBibliography,
    GenerateReportComponent,
    DialogConfirmSearchComponent,
    EditBibliographyComponent,
    DialogBibliographyBookComponent,
    ListBibliographyComponent,
    DialogAssignBibliographyComponent
  ],
  entryComponents: [
    DialogContributorsComponent,
    DialogPublishersComponent,
    DialogNewContributorComponent,
    DialogConfirmDeleteCCBCSubject,
    DialogCCBCSubjectsComponent,
    DialogConfirmDeleteBook,
    DialogConfirmDeleteBibliography,
    DialogConfirmSearchComponent,
    DialogBibliographyBookComponent,
    DialogAssignBibliographyComponent //dialog 
  ],
  imports: [
    AuthModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    TreeModule.forRoot(),  //angular-tree-component
    EditorModule //tinymce
  ],
  exports: [
    SharedModule
  ],
  providers: [
    ListBooksService,
    ContributorService,
    PagerService,
    OrderByPipe,
    SearchFilterPipe,
    RemoveDuplicatesPipe,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    BibliographyService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
